







































import { ConsultoresService, FiltroEnviosAutomaticos } from '@/services/consultores.service';
import DataTable, { TableHeader } from '@/shared/components/data-table.vue';
import { dateTime, timeFromNow } from '@/shared/filters';
import { ServerPageOptions } from '@/shared/utils/datatable';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import FiltrosEnvioAutomaticoForm from '../components/FiltrosEnvioAutomaticoForm.vue';
import { ehFalhaDeEnvio, StatusEnvioExecucao } from '@/shared/enumeradores';

@Component({
    components: {
        DataTable,
        FiltrosEnvioAutomaticoForm,
    },
    filters: { dateTime, timeFromNow },
})
export default class EnviosAutomaticos extends Vue {
    @Prop({ required: true }) idConsultor!: number;
    @Prop({ default: true }) disablePagination!: boolean;
    @Prop() filtros?: FiltroEnviosAutomaticos;

    envios: Promise<any> | any | null = null;
    loading = false;

    headers: TableHeader[] = [
        { value: 'dataCriacao', text: 'Data', withAliasValue: 'e.DataCriacao' },
        { value: 'tipo', text: 'Tipo', withAliasValue: 'ea.Nome' },
        { value: 'status', text: 'Status', sortable: false },
    ];

    @Watch('idConsultor', { immediate: true })
    @Watch("filtros")
    onChange() {
        this.fetchEnviosAutomaticos();
    }

    async fetchEnviosAutomaticos(options?: ServerPageOptions) {
        this.onLoadingChange(true);

        let filtros: FiltroEnviosAutomaticos = { idConsultor: this.idConsultor };

        if (this.filtros) {
            filtros = { ...filtros, ...this.filtros };
        }

        if (options) {
            filtros = { ...filtros, ...options };
        }

        this.envios = ConsultoresService.PesquisarEnviosAutomaticos(filtros).finally(() => {
            this.onLoadingChange(false);
        });
    }

    ehFalhaDeEnvio(status: StatusEnvioExecucao) {
        return ehFalhaDeEnvio(status);
    }

    itemClass(item: any) {
        return ehFalhaDeEnvio(item.status) ? null : 'not-expandable';
    }

    @Emit('loadingChange')
    onLoadingChange(loading: boolean) {
        return this.loading = loading;
    }
}
